// src/modules/components/reports/calls/CallReportsFilters.js
import React from "react";
import {
  Card,
  Grid,
  Typography,
  MenuItem,
  Select,
  TextField as MuiTextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

const CallReportsFilters = ({ filters, onFilterChange }) => {
  const timeRanges = [
    { value: "", label: "All Time" },
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "this_week", label: "This Week" },
    { value: "last_week", label: "Last Week" },
    { value: "this_month", label: "This Month" },
    { value: "last_month", label: "Last Month" },
    { value: "last_3_months", label: "Last 3 Months" },
    { value: "custom", label: "Custom Range" },
  ];

  const dispositions = [
    { value: "", label: "All" },
    { value: "ANSWERED", label: "Answered" },
    { value: "NO ANSWER", label: "No Answer" },
    { value: "BUSY", label: "Busy" },
    { value: "FAILED", label: "Failed" },
  ];

  const callTypes = [
    { value: "", label: "All" },
    { value: "incoming", label: "Incoming" },
    { value: "outgoing", label: "Outgoing" },
    { value: "internal", label: "Internal" },
  ];

  return (
    <Card sx={{ mb: 3, p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="subtitle2">Time Range</Typography>
          <Select
            fullWidth
            value={filters.timeRange}
            onChange={(e) => onFilterChange("timeRange", e.target.value)}
            size="small"
          >
            {timeRanges.map((range) => (
              <MenuItem key={range.value} value={range.value}>
                {range.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="subtitle2">Call Type</Typography>
          <Select
            fullWidth
            value={filters.callType}
            onChange={(e) => onFilterChange("callType", e.target.value)}
            size="small"
          >
            {callTypes.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="subtitle2">Disposition</Typography>
          <Select
            fullWidth
            value={filters.disposition}
            onChange={(e) => onFilterChange("disposition", e.target.value)}
            size="small"
          >
            {dispositions.map((disp) => (
              <MenuItem key={disp.value} value={disp.value}>
                {disp.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="subtitle2">Agent ID</Typography>
          <MuiTextField
            fullWidth
            size="small"
            value={filters.agentId}
            onChange={(e) => onFilterChange("agentId", e.target.value)}
            placeholder="Enter agent ID"
          />
        </Grid>
        {filters.timeRange === "custom" && (
          <>
            <Grid item xs={12} sm={6} md={2}>
              <DatePicker
                label="Start Date"
                value={filters.startDate || null}
                onChange={(newDate) => {
                  const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
                  onFilterChange("startDate", iso);
                }}
                renderInput={(params) => (
                  <MuiTextField
                    {...params}
                    fullWidth
                    size="small"
                    inputProps={{ ...params.inputProps, readOnly: true }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <DatePicker
                label="End Date"
                value={filters.endDate || null}
                onChange={(newDate) => {
                  const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
                  onFilterChange("endDate", iso);
                }}
                renderInput={(params) => (
                  <MuiTextField
                    {...params}
                    fullWidth
                    size="small"
                    inputProps={{ ...params.inputProps, readOnly: true }}
                  />
                )}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Card>
  );
};

export default CallReportsFilters;